import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { oktaTokenBaseQuery } from "@/react/services/api";
import Debug from "@/react/debug";

const unbindVmmsUrl = `/v1/customers/unbind-vmms`;

export const unbindVmmsApi = createApi({
  reducerPath: "unbindVmms",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (build) => ({
    unbindVmms: build.mutation({
      query: (data) => ({
        url: unbindVmmsUrl,
        body: data,
        method: "POST",
      }),
    }),
  }),
});

export const { useUnbindVmmsMutation } = unbindVmmsApi;

const OPERATION_RESULT_SUCCESS = "SUCCESS";
const OPERATION_RESULT_FAILURE = "FAILURE";

export const createUnbindVmmsResponseHandler =
  ({ setData }) =>
  (response) => {
    Debug.log("Received unbind response", response);
    const mappedData = [];
    let stepCount = 1;
    // Response is an array of responses for each step of the process
    response.forEach((stepResponse) => {
      const opResult = stepResponse.operationResult;
      const { result, details } = opResult?.success
        ? { result: OPERATION_RESULT_SUCCESS, details: opResult.success }
        : {
            result: OPERATION_RESULT_FAILURE,
            details: opResult.failure.message,
          };
      mappedData.push({
        step: stepCount++,
        operation: stepResponse.identifier,
        result: result,
        details: details,
      });
    });
    setData(mappedData);
  };
